export enum PublicShipmentDetailsPath {
  probill = "probill"
}

export interface PathParams {
  [PublicShipmentDetailsPath.probill]: string;
}
